import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Dialog from 'components/Common/Modals/Dialog'
import { ActionsBlock, Body, Description, Main, Title } from './_styles'
import { Button, ButtonContent } from 'components/Common/MasterComponents'
import {
  Counter,
  Error as ErrorMessage,
} from 'components/Common/MasterComponents/Textarea/_styles'
import Textarea from 'components/Common/MasterComponents/Textarea'

interface IncorrectRecognitionDialogProps {
  onClose: () => void
  onSubmit: (comment: string) => void
  loading?: boolean
}
const MAX_LENGTH = 300

const IncorrectRecognitionDialog: FC<IncorrectRecognitionDialogProps> = ({
  onClose,
  onSubmit,
  loading = false,
}) => {
  const { t } = useTranslation()
  const [comment, setComment] = useState('')
  const [error, setError] = useState('')
  const symbolsLeft = MAX_LENGTH - (comment || '').length

  const handleTextChange = e => {
    setComment(e.target.value.slice(0, MAX_LENGTH))
    setError('')
  }

  const handleIncorrectRecognition = () => {
    if (comment.length <= 1) {
      setError(t('error.fieldRequired'))
      return
    }
    setError('')
    onSubmit(comment)
  }

  return (
    <Dialog.Wrapper withMobileVariant onClose={onClose}>
      <Dialog.Main width='576px'>
        <Dialog.Header
          title={t('accountSetup.incorrectDialog.header')}
          onClose={onClose}
        />
        <Dialog.Content>
          <Body>
            <Main>
              <Title>{t('accountSetup.incorrectDialog.title')}</Title>
              <Description>
                {t('accountSetup.incorrectDialog.desc')}
              </Description>
              <Textarea
                placeholder={t('accountSetup.incorrectDialog.textArea')}
                maxLength={MAX_LENGTH}
                height={124}
                value={comment}
                onChange={handleTextChange}
                after={<Counter>{symbolsLeft}</Counter>}
              />
              {error && <ErrorMessage>{error}</ErrorMessage>}
            </Main>
            <ActionsBlock>
              <Button $size='L' $type='secondary' onClick={onClose}>
                {t('common.cancel')}
              </Button>
              <Button
                $size='L'
                $type='primary'
                onClick={handleIncorrectRecognition}
                $fakeDisabled={loading || comment.length <= 1}
              >
                <ButtonContent loading={loading}>
                  {t('common.confirm')}
                </ButtonContent>
              </Button>
            </ActionsBlock>
          </Body>
        </Dialog.Content>
      </Dialog.Main>
    </Dialog.Wrapper>
  )
}

export default IncorrectRecognitionDialog
